export function saveDatosReportesProconsumo(datosReportesProconsumo) {
  return function (dispatch) {
    dispatch({
      type: "SAVE_DATOS_REPORTES_PROCONSUMO",
      payload: {
        datosReportesProconsumo: datosReportesProconsumo
      }
    })
  }
}